import axios from "axios";


export default {
	// 获取配置
	getConfigKey: (key) => {
		return axios.get(`/a1/config/${key}`);
	},
	// 更新配置
	UpdateConfigKey: (key, val) => {
		return axios.put(`/a1/config/${key}/${val}`);
	}
}